// extracted by mini-css-extract-plugin
export default {"alert":"roUEUbLEmqojvDw9DS13","header":"jsgg4D99XR0LUDdlwZiV","content":"Qw_ALGtSixgzCoxbPNqP"};